import {getBrandConfig} from "@/brand";
import store from "../store";
import {GameToBrandMap} from "@/brand/brandConfig";

export function setBrandConfig() {
    if (store.state.brandConfig && store.state.productId) {
        return;
    }

    const brandConfig = getBrandConfigFromGameParameter();
    store.commit('setBrandConfig', brandConfig);
}

export function getBrandConfigFromGameParameter() {
    const urlParams = new URLSearchParams(window.location.search);
    const productId = urlParams.get('productId');
    if (!store.state.productId) {
        store.commit('setProductId', productId);
    }

    if (productId && GameToBrandMap.has(Number(productId))) {
        return getBrandConfig(GameToBrandMap.get(Number(productId)));
    } else {
        return getBrandConfig(44); // Default is 4
    }
}

